module.exports = __webpack_public_path__ + "static/essentia+web3-74d4d5e9fd6189c04931bb62d1a10e78.svg";